import { render, staticRenderFns } from "./ResourceHeader.vue?vue&type=template&id=3594a711&"
import script from "./ResourceHeader.vue?vue&type=script&lang=ts&"
export * from "./ResourceHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ResourceHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports